import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

import { NorificationIcon } from '../models/notification-icon.enum';

type DialogPosition = 'top' | 'bottom' | 'middle';

interface ToastConfig {
  class: string;
  icon: string;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  private loadCrl: HTMLIonToastElement;

  private map = new Map<NorificationIcon, ToastConfig>([
    [
      NorificationIcon.MESSAGE,
      {
        class: 'toast-messages',
        icon: 'chatbubble-ellipses-outline'
      }
    ],
    [
      NorificationIcon.ALERT,
      {
        class: 'toast-alert',
        icon: 'alert-circle-outline'
      }
    ],
    [
      NorificationIcon.SECONDARY,
      {
        class: 'toast-secondary',
        icon: 'alert-circle-outline'
      }
    ]
  ]);
  private opened = false;

  constructor(private toastController: ToastController) {}

  async openDialog(message: string, duration = 6000, position: DialogPosition = 'top', notificationIcon = NorificationIcon.MESSAGE): Promise<void> {
    if (this.opened) {
      return;
    }

    this.opened = true;
    this.loadCrl = await this.toastController.create({
      message,
      duration,
      position,
      icon: this.map.has(notificationIcon) ? this.map.get(notificationIcon).icon : '',
      buttons: [
        {
          text: 'Dismiss',
          role: 'cancel'
        }
      ],
      cssClass: this.map.has(notificationIcon) ? this.map.get(notificationIcon).class : ''
    });

    await this.loadCrl.present();
    this.loadCrl.onDidDismiss().then(() => {
      this.opened = false;
    });
  }
}
